import { render, staticRenderFns } from "./ViewArvore.vue?vue&type=template&id=2007bb35"
import script from "./ViewArvore.vue?vue&type=script&lang=js"
export * from "./ViewArvore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports